module.exports = __webpack_public_path__ + "img/new-release-2.0b3b75da.png";